import React from "react";

export const Header = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md col-md-offset-2 intro-text">
                <h1 style={{paddingLeft:'300px'}}>
                  Bible iTreasure Kids
                  <span></span>
                </h1>
                <p style={{paddingLeft:'300px'}}>
                  Learn the Holy Bible through fun games, stories, and
                  challenges — designed for every age group.
                </p>
                {/* <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>{" "} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
